import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import colors from '@front/common/src/utils/colors';
import { CommonModalProps } from '@front/common/src/types/components';

import { translate } from '@front/i18n';

import { minWidth } from '../../styles/mixins';
import IconButton from '../button/icon-button';

import ModalContainerWithBackdrop, { MODAL_ANIMATION_DURATION } from './modal-container-with-backdrop';
import { slideDown, slideUp } from './common';
import AccessibleModal from './accessible-modal';

const t = translate('base');

type StyledModalProps = { $isOpen: boolean };

const StyledModal = styled(AccessibleModal)<StyledModalProps>`
  width: 100%;
  height: 100%;
  background-color: ${colors.white100};
  overflow-y: auto;
  animation: ${({ $isOpen }: StyledModalProps) => ($isOpen ? slideUp : slideDown)} ${MODAL_ANIMATION_DURATION}ms ease
    forwards;

  ${minWidth.md`
    max-width: 650px;
    margin: auto;
  `}
`;

const CloseIcon = styled(IconButton)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
`;

type FullHeightCenteredModalProps = PropsWithChildren<Omit<CommonModalProps, 'onClose'>> & {
  onClose?: () => void;
};

const FullHeightCenteredModal = ({ isOpen, onClose, children }: FullHeightCenteredModalProps) => (
  <ModalContainerWithBackdrop isOpen={isOpen} onClose={onClose} hasBackdropBlur>
    <StyledModal $isOpen={isOpen}>
      {!!onClose && (
        <CloseIcon type='whitedark' onPress={onClose} size={30} iconSize={13} iconName='close' label={t('.close')} />
      )}
      {children}
    </StyledModal>
  </ModalContainerWithBackdrop>
);

export default FullHeightCenteredModal;
